"use client"

import { useEffect, useState } from "react"

/**
 * useMediaQuery
 * React-hook to listen to a CSS media query.
 *
 * @example
 * const isMobile = useMediaQuery("(max-width: 768px)")
 */
export function useMediaQuery(query: string): boolean {
  const getMatches = () => (typeof window !== "undefined" ? window.matchMedia(query).matches : false)

  const [matches, setMatches] = useState<boolean>(getMatches)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query)
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches)

    mediaQueryList.addEventListener("change", listener)
    // Edge / Safari fallback
    mediaQueryList.addListener?.(listener)

    return () => {
      mediaQueryList.removeEventListener("change", listener)
      mediaQueryList.removeListener?.(listener)
    }
  }, [query])

  return matches
}
